import React from 'react';

interface Props {
    icon: JSX.Element
}

const RoundedIcon = ({icon}: Props) => {
	return (
		<div className='rounded-icon'>
            {icon}
		</div>
	)
}

export default RoundedIcon;